import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material';
import Iconify from '../../components/Iconify';
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';

// ── Tokens ────────────────────────────────────────────────────────────────────
const DRAWER_W       = 252;
const APPBAR_MOBILE  = 64;
const APPBAR_DESKTOP = 72;
const VIOLET         = 'var(--color-primary-main)';
const T2             = '#475569';

// ── Pure white navbar — no blur, no translucency, no color bleed ──────────────
const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})(({ theme, collapsed }) => ({
  backgroundColor: '#FFFFFF',
  boxShadow: '0 1px 0 #E2E8F0',     // single clean 1px bottom border
  transition: theme.transitions.create('width', { duration: theme.transitions.duration.shorter }),
  [theme.breakpoints.up('lg')]: {
    width: collapsed ? '100%' : `calc(100% - ${DRAWER_W + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 3, 0, 1.5),
  },
}));

// 3px violet accent strip at very top of navbar
const VioletStrip = styled('div')(() => ({
  position: 'absolute',
  top: 0, left: 0, right: 0,
  height: 3,
  background: 'linear-gradient(90deg, var(--color-primary-main), var(--color-primary-light), #38BDF8)',
  borderRadius: 0,
}));

DashboardNavbar.propTypes = { onToggleSidebar: PropTypes.func, collapsed: PropTypes.bool };

export default function DashboardNavbar({ onToggleSidebar, collapsed }) {
  return (
    <RootStyle collapsed={collapsed}>
      <VioletStrip />
      <ToolbarStyle>
        <IconButton
          onClick={onToggleSidebar}
          sx={{
            mr: 1,
            color: T2,
            borderRadius: '10px',
            '&:hover': { background: 'rgba(var(--color-primary-main-rgb), 0.06)', color: VIOLET },
          }}
        >
          <Iconify icon={collapsed ? 'eva:menu-fill' : 'eva:menu-2-fill'} />
        </IconButton>

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
